module.exports = __webpack_public_path__ + "static/media/focus-active-cercle.8a06061a.png";